export const topBarHeight = 64;
export const navbarHeight = 60;
export const sideNavWidth = 260;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

export const CAMPAIGN_MEDIAS_MAX = 3;

export const MODE_UNKNOWN = "mode_unknown";
export const MODE_EDIT = "mode_edit";
export const MODE_ADD = "mode_add";

export const TAB_MEMBER_LIST_SEARCH = "1";
export const TAB_MEMBER_LIST_IDENTITY = "2";
export const TAB_MEMBER_LIST_ADVANCE = "3";

const BACKEND_HOST = process.env.REACT_APP_DEFAULT_IP || "https://membershipuat.maxisense.io";
// const BACKEND_HOST = "https://member-ytnec.yang.org.hk";

// In development, use relative URLs so requests are routed through the CRA
// dev proxy defined in src/setupProxy.js (avoids browser CORS errors).
// In production builds, hit the backend directly.
export const DEFAULT_IP = process.env.NODE_ENV === "development" ? "" : BACKEND_HOST;
export const LOGO_PATH = "/assets/images/maxisense.png";

// In dev, point at the dev server so the request goes through setupProxy.js
// (the proxy has ws: true and changeOrigin, which fixes Origin-based rejections).
// In prod, build the wss:// URL from the backend host as before.
const buildDevWsUrl = () => {
  if (typeof window === "undefined") return "";
  const scheme = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${scheme}//${window.location.host}/prod`;
};

export const WS_URL =
  process.env.REACT_APP_WS_URL ||
  (process.env.NODE_ENV === "development"
    ? buildDevWsUrl()
    : BACKEND_HOST.replace(/^https:/, "wss:").replace(/^http:/, "ws:") + "/prod");